export default {
	name: "add-or-edit-depot-discount-group",
	props: {
		customerDepotDiscountGroupId: {
			default: null
		}
	},
	data() {
		return {
			depots: [],
			productsToLinkHeadings:[
				{
					text: "Product",
					field: "name"
				},
				// {
				// 	text: "Original Price",
				// 	field: "priceAsString"
				// },
				{
					text: "Discount Amount",
					field: "discountAmountAsString"
				},
				// {
				// 	text: "Price After Discount",
				// 	field: "priceAfterDiscountAsString"
				// }
			],
			companiesToLinkToDiscountGroupHeadings: [
				{
					text: "Name",
					field: "registeredCompanyName"
				},
				{
					text: "Company Registration Number",
					field: "companyRegistrationNumber"
				},
				{
					text: "VAT Number",
					field: "taxVatNumber"
				},
			],
			customerDiscountGroupAddEditForm:{
				customerDiscountGroup:{
					customerDiscountGroupId: null,
					isActive: true,
					depotId:{
						value: null,
						hasError: false,
						errorMessage: null
					},
					name: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					discountAmount: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					effectiveDate: {
						value: new Date(),
						hasError: false,
						errorMessage: null
					},
					linkedProducts:{
						value: [],
						hasError: false,
						errorMessage: null
					},
					unlinkedProducts:{
						value: [],
						hasError: false,
						errorMessage: null
					},
					linkedCustomers: {
						value: [],
						hasError: false,
						errorMessage: null
					},
					unlinkedCustomers: {
						value: [],
						hasError: false,
						errorMessage: null
					}
				}
			},
			linkProductsToDiscountGroupModal: {
				showModal: false,
				isSaving: false,
				modalId: "linkProductsToDiscountGroupModal",
				heading: "Link Products To Discount Group",
				customerDiscountGroupId: null
			},
			linkCustomersToDiscountGroupModal: {
				showModal: false,
				modalId: "linkCustomerToDiscountGroupModal",
				heading: "Link Customers To Discount Group",
				customerDiscountGroupId: null
			},
			errorModal:{
				modalHeading: "Error",
				elementId: "customerModalError",
				modalMessage: "",
				showModal: false
			},
			successModal:{
				modalHeading: "Success",
				elementId: "customerModalSuccess",
				modalMessage: "",
				showModal: false
			},
			loading: false,
			loadingFromApi: false,
			productIdThatWasUnlinked: null,
			companyIdThatWasUnlinked: null,
			initialiseDate: true
		};
	},
	methods: {
		getDepotDiscountGroup(){
			this.loading = true;
			orderService.getDepotDiscountGroup(this.customerDepotDiscountGroupId).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.customerDiscountGroupAddEditForm.customerDiscountGroup.customerDiscountGroupId = successResponse.data.result.depotDiscountGroupId;
						this.customerDiscountGroupAddEditForm.customerDiscountGroup.isActive = successResponse.data.result.isActive;
						this.customerDiscountGroupAddEditForm.customerDiscountGroup.depotId.value = successResponse.data.result.depotId;
						this.customerDiscountGroupAddEditForm.customerDiscountGroup.name.value = successResponse.data.result.name;
						this.customerDiscountGroupAddEditForm.customerDiscountGroup.discountAmount.value = successResponse.data.result.discountAmount;
						let self = this;
						setTimeout(function (){
							self.customerDiscountGroupAddEditForm.customerDiscountGroup.effectiveDate.value = new Date(successResponse.data.result.effectiveDate);
						}, 500)
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getDepots(){
			this.loading = true;
			let request = {
				isActive: true,
				provinceId: 0
			};
			systemService.getAllDepots(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.depots = successResponse.data.result;
						this.depots = $.map(this.depots,
							function (obj) {
								obj.id = obj.id || obj.depotId;
								obj.text = obj.text || obj.name;
								return obj;
							});
						
						this.depots = dataTableHelper.castFieldValues(this.depots);
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onDepotSelect(depot){
			this.customerDiscountGroupAddEditForm.customerDiscountGroup.depotId.value = depot.id;
			this.customerDiscountGroupAddEditForm.customerDiscountGroup.depotId.hasError = false;
			this.customerDiscountGroupAddEditForm.customerDiscountGroup.depotId.errorMessage = null;
		},
		onEffectiveDateSelected(effectiveDate){
			this.customerDiscountGroupAddEditForm.customerDiscountGroup.effectiveDate.value = effectiveDate;
			this.customerDiscountGroupAddEditForm.customerDiscountGroup.effectiveDate.hasError = false;
			this.customerDiscountGroupAddEditForm.customerDiscountGroup.effectiveDate.errorMessage = null;
			this.initialiseDate = false;
		},
		onDiscountAmountChange(){
			if(this.customerDiscountGroupAddEditForm.customerDiscountGroup.discountAmount.value !== null && this.customerDiscountGroupAddEditForm.customerDiscountGroup.discountAmount > 0){
				for(let i = 0; i < this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedProducts.value.length; i++){
					this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedProducts.value[i].discountAmount = this.customerDiscountGroupAddEditForm.customerDiscountGroup.discountAmount.value;
					this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedProducts.value[i].discountAmountAsString = currencyHelper.numberToCurrency(this.customerDiscountGroupAddEditForm.customerDiscountGroup.discountAmount.value);
				}
			}
		},
		onCustomersLink(){
			console.log("onCustomersLink");
			this.linkCustomersToDiscountGroupModal.showModal = true;
		},
		onCustomerUnlink(companyId){
			let company = this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedCustomers.value.find(company => company.companyId === companyId);
			this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedCustomers.value = this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedCustomers.value.filter(company => company.companyId !== companyId);
			this.customerDiscountGroupAddEditForm.customerDiscountGroup.unlinkedCustomers.value.push(company);
			this.companyIdThatWasUnlinked = companyId;
		},
		onCustomersLinkedOrUnlinked(customers){
			this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedCustomers.value = JSON.parse(JSON.stringify(customers.customersToLink));
			this.customerDiscountGroupAddEditForm.customerDiscountGroup.unlinkedCustomers.value = JSON.parse(JSON.stringify(customers.customersToUnlink));
			console.log("linkedCustomers", this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedCustomers.value);
			if(customers.isSaving){
				this.linkCustomersToDiscountGroupModal.showModal = false;
			}
			this.companyIdThatWasUnlinked = null;
		},
		onLinkCustomersToDiscountGroupModalOkClick(){
			this.linkCustomersToDiscountGroupModal.showModal = false;
			this.companyIdThatWasUnlinked = null;
		},
		onLinkProductsClick(){
			this.linkProductsToDiscountGroupModal.showModal = true;
		},
		onProductUnlink(productId) {
			let product = this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedProducts.value.find(product => product.productId === productId);
			this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedProducts.value = this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedProducts.value.filter(product => product.productId !== productId);
			this.customerDiscountGroupAddEditForm.customerDiscountGroup.unlinkedProducts.value.push(product);
			this.productIdThatWasUnlinked = productId;
		},
		onProductsLinkedOrUnlinked(products) {
			this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedProducts.value = products.productIdsToLink === null ? [] : JSON.parse(JSON.stringify(products.productIdsToLink));
			this.customerDiscountGroupAddEditForm.customerDiscountGroup.unlinkedProducts.value = products.productIdsToUnlink === null ? [] : JSON.parse(JSON.stringify(products.productIdsToUnlink));
			if(products.isSaving){
				this.linkProductsToDiscountGroupModal.showModal = false;
			}
			console.log("linkedProducts", this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedProducts.value);
		},
		onLinkProductsToCustomerGroupModalOkClick(){
			this.linkProductsToDiscountGroupModal.showModal = false;
		},
		errorModelOkClicked() {
			this.errorModal.showModal = false;
		},
		successModelOkClicked() {
			this.successModal.showModal = false;
			this.$router.go(-1);
		},
		onBackClick() {
			this.$router.go(-1);
		},
		onAddOrEditCustomerDiscountGroupSaveClick(){
			this.loading = true;
			var productIdsToLink = [];
			var productIdsToUnlink = [];
			var companyIdsToLink = [];
			var companyIdsToUnlink = [];
			productIdsToLink = this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedProducts.value.map(product => product.productId);
			productIdsToUnlink = this.customerDiscountGroupAddEditForm.customerDiscountGroup.unlinkedProducts.value.map(product => product.productId);
			companyIdsToLink = this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedCustomers.value.map(company => company.companyId);
			companyIdsToUnlink = this.customerDiscountGroupAddEditForm.customerDiscountGroup.unlinkedCustomers.value.map(company => company.companyId);
			let request ={
				depotDiscountGroupId: this.customerDiscountGroupAddEditForm.customerDiscountGroup.customerDiscountGroupId === null ? 0 : this.customerDiscountGroupAddEditForm.customerDiscountGroup.customerDiscountGroupId,
				name: this.customerDiscountGroupAddEditForm.customerDiscountGroup.name.value,
				discountAmount: this.customerDiscountGroupAddEditForm.customerDiscountGroup.discountAmount.value === null ? 0 : this.customerDiscountGroupAddEditForm.customerDiscountGroup.discountAmount.value,
				isActive: this.customerDiscountGroupAddEditForm.customerDiscountGroup.isActive,
				depotId: this.customerDiscountGroupAddEditForm.customerDiscountGroup.depotId.value === null ? 0 : this.customerDiscountGroupAddEditForm.customerDiscountGroup.depotId.value,
				effectiveDate: this.customerDiscountGroupAddEditForm.customerDiscountGroup.effectiveDate.value,
				productIdsToLink: productIdsToLink,
				productIdsToUnlink: productIdsToUnlink,
				companyIdsToLink: companyIdsToLink,
				companyIdsToUnlink: companyIdsToUnlink
			};
			orderService.addOrUpdateDepotDiscountGroup(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						if(successResponse.data.depotDiscountGroupValidationResponse.valuesAreValid){
							this.successModal.modalMessage = "Depot Discount Group saved successfully.";
							this.successModal.showModal = true;
						}
						else{
							this.customerDiscountGroupAddEditForm.customerDiscountGroup.name.hasError = successResponse.data.depotDiscountGroupValidationResponse.nameValidationResponse.hasError;
							this.customerDiscountGroupAddEditForm.customerDiscountGroup.name.errorMessage = successResponse.data.depotDiscountGroupValidationResponse.nameValidationResponse.message;
							this.customerDiscountGroupAddEditForm.customerDiscountGroup.discountAmount.hasError = successResponse.data.depotDiscountGroupValidationResponse.discountAmountValidationResponse.hasError;
							this.customerDiscountGroupAddEditForm.customerDiscountGroup.discountAmount.errorMessage = successResponse.data.depotDiscountGroupValidationResponse.discountAmountValidationResponse.message;
							this.customerDiscountGroupAddEditForm.customerDiscountGroup.depotId.hasError = successResponse.data.depotDiscountGroupValidationResponse.depotValidationResponse.hasError;
							this.customerDiscountGroupAddEditForm.customerDiscountGroup.depotId.errorMessage = successResponse.data.depotDiscountGroupValidationResponse.depotValidationResponse.message;
							this.customerDiscountGroupAddEditForm.customerDiscountGroup.effectiveDate.hasError = successResponse.data.depotDiscountGroupValidationResponse.effectiveDateValidationResponse.hasError;
							this.customerDiscountGroupAddEditForm.customerDiscountGroup.effectiveDate.errorMessage = successResponse.data.depotDiscountGroupValidationResponse.effectiveDateValidationResponse.message;

							this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedCustomers.hasError = successResponse.data.depotDiscountGroupValidationResponse.companyIdsToLinkResponse.hasError;
							this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedCustomers.errorMessage = successResponse.data.depotDiscountGroupValidationResponse.companyIdsToLinkResponse.message;

							this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedProducts.hasError = successResponse.data.depotDiscountGroupValidationResponse.productIdsToLinkValidationResponse.hasError;
							this.customerDiscountGroupAddEditForm.customerDiscountGroup.linkedProducts.errorMessage = successResponse.data.depotDiscountGroupValidationResponse.productIdsToLinkValidationResponse.message;
						}
					}
					this.loading = false;
				},
				errorResponse => {
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		setBreadcrumbs() {
			var pageTitle = "Add Depot Discount Group";
			if(this.customerDiscountGroupId != null && this.customerDiscountGroupId > 0){
				pageTitle = "Edit Depot Discount Group";
			}
			storeState.setPageTitleAction(pageTitle);
			breadcrumbsStoreState.updateBreadcrumbs(this.$route, pageTitle);
		}
	},
	mounted: function () {
		this.getDepots();
	},
	watch:{
		customerDepotDiscountGroupId:{
			handler: function () {
				if(this.customerDepotDiscountGroupId !== null && this.customerDepotDiscountGroupId > 0){
					this.getDepotDiscountGroup();
				}
				this.setBreadcrumbs();
				console.log("customerDepotDiscountGroupId", this.customerDepotDiscountGroupId);
				this.customerDiscountGroupAddEditForm.customerDiscountGroup.customerDiscountGroupId = this.customerDepotDiscountGroupId === null || this.customerDepotDiscountGroupId === "" ? 0 : this.customerDepotDiscountGroupId;
			},
			immediate: true,
			deep: true
		}
	}
};